/* eslint-disable no-param-reassign */
/* eslint-disable no-useless-escape */
/* eslint-disable react-hooks/exhaustive-deps */
import { ArrowDownIcon2, ArrowLeftCircle, AutoRenewIcon, Button, Flex, Heading, IconSort, LocationV2Icon, Text, useModal } from "@pancakeswap/uikit";
import { Spin } from 'antd';
import BigNumber from "bignumber.js";
import ConnectWalletButton from "components/ConnectWalletButton";
import Container from "components/Layout/Container";
import PageFullWidth from "components/Layout/PageFullWidth";
import { OptionProps } from "components/Select/SelectProvince";
import SelectProvinceHome from "components/Select/SelectProvinceHome";
import { TYPE_GIFTCARD, UNIT_TOKEN } from "config";
import { BrandApi } from "config/api/brand";
import province from "config/constants/address/province.json";
import contracts from "config/constants/contracts";
import { listTokenGetBalance } from "config/giftcards";
import useActiveWeb3React from "hooks/useActiveWeb3React";
import useTheme from "hooks/useTheme";
import { useRouter } from 'next/router';
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "state";
import { GetDataAuth, UseCoreNonce } from "state/auth";
import { GetDataGiftCards, UseCoreDataUser, UseCorePaymentMethod } from "state/giftCards";
import { fetchActiveCategory, fetchDataUserByChain, fetchDataVouchers, fetchDetailBrand, fetchFillAmount, fetchFillEmail, fetchFillPhoneNumber, fetchListProvinceByBrandId, fetchProvinceId, fetchStatusScreen, getStatusLoading } from "state/giftCards/actions";
import { fetchBalanceByChain, fetchBrandById, fetchNewBrandById } from "state/giftCards/fetchData";
import { BrandItem, Brandtype, productType } from "state/giftCards/type";
import styled from "styled-components";
import { Navigation, Swiper as SwiperType } from 'swiper';
import 'swiper/css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { getAddress } from "utils/addressHelpers";
import { formatNumber, formatNumberv2 } from "utils/formatNumber";
import Filter from "./components/Filter";
import GiftCardList from "./components/GiftCardList";
import Info from "./components/Info";
import ModalInfo from "./components/ModalInfo";
import { ViewTag } from "./config";
import { CsButton, CsButtonTab, CsHeading, SubBalance } from "./styles";

interface Props {
    priceRoute: string,
    brandRoute:string
    productRoute:string,
    phoneNumberRoute?:string,
    newbrand?:string
}

const ElectronicGiftCard:React.FC<Props> = ({ priceRoute, brandRoute, productRoute, phoneNumberRoute, newbrand }) => {
    const { theme } = useTheme()
    const router = useRouter()
    
    const { account, chainId, provider } = useActiveWeb3React()
    const swiperRef = useRef<SwiperType>();
    const dispatch = useDispatch<AppDispatch>()
    const dataGiftcards = GetDataGiftCards()
    UseCoreNonce()
    const dataAuth = GetDataAuth()
    const {email: emailAuth, phone: phoneAuth} = dataAuth
    const { ListCategory, brandItem: brandItemStore, category, ListBrand , ListProvinceId, isLoading, phoneNumber, fillAmount, dataVouchers, isUpdate, tokenSupport, activeTokenPayment } = dataGiftcards
    const brandItem = brandItemStore?.filter((item) => Number(item?.price) !== 0)
    const findNameItem = ListBrand?.find((item) => item?.id?.toString() === brandRoute?.toString())
    const findNameUpdateItem = ListBrand?.find((item) => item?.title?.toString() === dataVouchers?.brandName?.toString())
    const [deliveryMethod, setDeliveryMethod] = useState('email')
    const [selectCategory, setSelectCategory ] = useState<string>('0')
    const [selectRegion, setSelectProvince ] = useState<number>()
    const [selectBrand, setSelectBrand ] = useState<Brandtype>()
    const [viewTag, setViewTag] = useState('1')
    const [cardPrice, setCardPrice] = useState<BrandItem | any>()
    const [cardProduct, setCardProduct] = useState<productType | any>()
    const [ noProduct, setNoProducts] = useState([])
    const [isError, setIsError ] = useState(false)
    const [ isDefaultBrand, setIsDefaultBrand] = useState(false)
    const [ isDefaultProvince, setIsDefaultProvince] = useState(false)
    const [optionSelected, setOptionSelected] = useState(false)
    const findProductRoute = brandItem?.find((item) => item?.id?.toLocaleLowerCase() === productRoute?.toLocaleLowerCase())
    const findPriceRoute = brandItem?.find((item) => Number(item?.price) === Number(priceRoute))
    const findPriceUpdate = brandItem?.find((item) => Number(item?.price) === Number(dataVouchers?.price))
    const voucherName =  selectBrand?.isNewBrand ? "[GiftCard Voucher]" : "[UrBox Voucher]"
    const findProductUpdate = useMemo(() => {
        if(viewTag ==='1'){
            return brandItem?.find((item) => Number(item?.price) === Number(dataVouchers?.price))
        }
        return '0'
    },[viewTag])
    useEffect(() => {
        (async () => {
            if((priceRoute === undefined && brandRoute === undefined) && (selectBrand === undefined || Number(selectRegion) === 0)){
                await dispatch(fetchListProvinceByBrandId({brandId: '0'}))
            }
        })()
    },[])

    useEffect(() => {
        (async() => {
            await dispatch(fetchActiveCategory({category:'0'}))
            await dispatch(fetchProvinceId({ cityId : '0'}))
            
            await setIsDefaultProvince(!false)
        })()
    },[])
    
    // // update
    useEffect(() => {
        if(dataVouchers?.price !== '' && isUpdate && !cardPrice){
            setCardPrice(findPriceUpdate)
        }
        if(dataVouchers && isUpdate && !cardProduct){
            setCardProduct(findProductUpdate)
        }
    },[findPriceUpdate,findProductUpdate, dataVouchers , isUpdate, findNameUpdateItem, selectBrand, viewTag, cardPrice])
    
    useEffect(() => {
        if(dataVouchers && isUpdate ){
            setViewTag(dataVouchers?.viewTag)
        }
    },[ViewTag])

    useEffect(() => {
        if(cardPrice === undefined && priceRoute && !isUpdate){
            setCardPrice(priceRoute)
        }
    },[])
    
    useEffect(() =>{
        (async() => {
            if((selectBrand === undefined && !findNameUpdateItem) || selectBrand === undefined  ){
                await setSelectBrand(findNameItem)
            }
            if(cardPrice === undefined && priceRoute && !isUpdate){
                await setCardPrice(findPriceRoute)
            }
            if(cardProduct === undefined && productRoute && !isUpdate){
                await setCardProduct(findProductRoute)
            }
        })()
    },[cardPrice, cardProduct, findNameItem, priceRoute, productRoute, selectBrand])

    const handleChangeCategory = async (newValue:string) => {
        setSelectCategory(newValue)
        setIsDefaultBrand(!false)
        setIsDefaultProvince(!false)
    }

    const handleSelectReliGion = async (option) => {
        setSelectProvince(option?.provinceId?.toString())
        await dispatch(fetchProvinceId({ cityId : option?.provinceId }))
    }

    useEffect(() => {
        if(findNameUpdateItem && !selectBrand && isUpdate){
            setSelectBrand(findNameUpdateItem)
        }
    },[findNameUpdateItem, selectBrand, isUpdate])

    // validation
    const phoneno = /^\d{10}$/;
    // eslint-disable-next-line no-useless-escape
    const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    
    const resultFilterCategory = useMemo(() => {
        if(Number(selectCategory) !== 0){
            return ListBrand?.filter((item) => Number(item?.parent_cat_id) === Number(selectCategory))
        }
        if(Number(selectCategory) === 0){
            return ListBrand
        }
        return []
    },[ListBrand, selectCategory])
    const resultFilterProvince = useMemo(() => {
        if(Number(selectRegion) !== 0){
            const mapListProvince = ListProvinceId?.map((item) => {
                const findItemByCategory = resultFilterCategory?.find((dt) => dt?.id?.toLocaleLowerCase() === item?.toLocaleLowerCase())
                return findItemByCategory
            })
            const resultFilterUndefine = mapListProvince?.filter((item) => item !== undefined)
            return resultFilterUndefine
        }
        if(Number(selectRegion) === 0 || selectRegion === undefined ){
            return resultFilterCategory
        }
        return []
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[selectRegion, ListProvinceId, resultFilterCategory, selectCategory])
    const resultFilterBrand:Brandtype = useMemo(() =>{
        if( Number(selectBrand?.id) !== 0 && resultFilterProvince?.length !== 0 ){
            return resultFilterProvince?.find((item) => item?.id?.toLocaleLowerCase() === selectBrand?.id?.toLocaleLowerCase())
        }
        return null
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[resultFilterProvince, selectBrand, selectCategory, selectRegion, ListBrand])
    
    useEffect(() => {
        if(findProductRoute || priceRoute){
            if(fillAmount === 0) {
                dispatch(fetchFillAmount({fillAmount:1}))
            } 
        }
    },[findProductRoute, priceRoute])
    
    function handleDecimalsOnValue(value) {
        const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;
        return value.match(regex)[0];
    }
    
    const handleChangeInput = (value) => {
        dispatch(fetchFillAmount({fillAmount:handleDecimalsOnValue(value)}))
    };

    const sliderSettings = {
        320: {
          slidesPerView: 3,
          spaceBetween: 5,
        },
        680: {
          slidesPerView: 6,
          spaceBetween: 0,
        },
        1024: {
          slidesPerView: 8,
          spaceBetween: 8,
        },
        1366: {
            slidesPerView: 8,
            spaceBetween: 8,
        },
    };

    const handleSelectPrice = (value) => {
        if(value){
            setCardPrice(value)
        }
    }

    const handleSelectCard = (value) => {
        if(value){
            setCardProduct(value)
        }
    }

    const handleBack = () => {
        router.back()
    }

    const allOption = [
        {
            id:'0',
            images: '',
            title: 'Tất cả',
        },
        {
            id: "1",
            images: "",
            title:"GiftCard"
        },
    ]
    
    const concatCategory = allOption?.concat(ListCategory)
    
    useEffect(() => {
        const getData = async() => {
                if(resultFilterBrand?.isNewBrand) {
                    const resBrandItem = await fetchNewBrandById(resultFilterBrand?.id)
                    dispatch(fetchDetailBrand(resBrandItem))
                    
                } else {
                    const resBrandItem = await fetchBrandById(resultFilterBrand?.id)
                    dispatch(fetchDetailBrand(resBrandItem))
                }
        }
        if (resultFilterBrand?.id){
            getData()
        }
        if (!Number(resultFilterBrand?.id)){
            setNoProducts([])
        }
    },[dispatch, resultFilterBrand, category, selectRegion, selectBrand])
    
    const filterTypeOne = [];
    (TYPE_GIFTCARD?.PRICE_VOUCHER)?.map((item) => {
        const arrayBrandItemNotNone = brandItem?.filter((dt) => Number(dt?.type) === Number(item))
        if( arrayBrandItemNotNone?.length !== 0){
            filterTypeOne?.push(arrayBrandItemNotNone)
        }
        return filterTypeOne
    })

    const filterTwo = [];
    (TYPE_GIFTCARD?.FEATURED_PRODUCT)?.map((item) => {
        const arrayBrandItemNotNone = brandItem?.filter((dt) => Number(dt?.type) === Number(item))
        
        if( arrayBrandItemNotNone?.length !== 0){
            filterTwo?.push(arrayBrandItemNotNone)
        }

        return filterTwo
    })
    const resultFilterTypeOne = useMemo(() => {
        if( filterTypeOne?.length === 0){
            return []
        }
        return filterTypeOne?.[0]
    },[filterTypeOne, selectBrand])
    
    const filterTypeTwo = useMemo(() => {
        if(filterTwo?.length === 0){
            return []
        }
        return filterTwo?.[0]
    },[filterTwo, selectBrand])
    
    const sortBrandItemOne = useMemo(() => {
        return resultFilterTypeOne?.sort((a,b) => Number(a?.price) - Number(b?.price))
    },[selectBrand, resultFilterTypeOne])
    
    const sortBrandItemTwo = useMemo(() => {
        return filterTypeTwo && [...filterTypeTwo]?.sort((a,b) => Number(a?.price) - Number(b?.price))
    },[selectBrand, filterTypeTwo ])
    const filterIsPrice = useMemo(() => {
        const price = cardPrice === undefined ? priceRoute?.toString() : cardPrice?.price?.toString()
        return sortBrandItemOne?.find((item) => item?.price?.toString() === price?.toString() )
    },[cardPrice])
    const filterIsProduct = useMemo(() => {
        const productFilter = cardProduct === undefined ? productRoute?.toString() : cardProduct?.id?.toString()
        return sortBrandItemTwo?.find((item) => item?.id?.toString() === productFilter?.toString())
    },[cardProduct])

    const priceRouteValue = (priceRoute && !cardPrice) ? priceRoute : filterIsPrice && filterIsPrice?.price?.toString()
    const productRouteValue = (productRoute && !cardProduct) ? findProductRoute?.price?.toString() : filterIsProduct ? filterIsProduct?.price?.toString() : 0

        const priceQuantity = cardPrice === undefined ? priceRoute?.toString() : cardPrice?.price?.toString()
        const productQuantity = cardProduct === undefined ? findProductRoute?.id?.toString() : cardProduct?.id?.toString()
    const checkFilterIsPrice = Number(sortBrandItemOne?.find((item) => item?.price?.toString() === priceQuantity?.toString())?.quantity) || 0
    const checkFilterIsProduct = Number(sortBrandItemTwo?.find((item) => item?.id?.toString() === productQuantity?.toString())?.quantity) || 0
    const stockQuantity = viewTag === '1' ? checkFilterIsPrice : checkFilterIsProduct
    const totalPrice = useMemo(() => {
        if(viewTag === '1'){
            if(priceRouteValue){
                if (filterIsPrice !== undefined) {
                    return new BigNumber(fillAmount)?.multipliedBy(Number(filterIsPrice?.is_promo) === 2 ? filterIsPrice?.price_promo : filterIsPrice?.price)?.toString()
                }
                if(filterIsPrice === undefined){
                    return new BigNumber(fillAmount)?.multipliedBy(Number(findPriceRoute?.is_promo) === 2 ? findPriceRoute?.price_promo : findPriceRoute?.price)?.toString()
                }
                return new BigNumber(fillAmount)?.multipliedBy(priceRouteValue)?.toString()
            } 
        }
        if(viewTag === '2'){
            if(productRouteValue) {
                if(filterIsProduct === undefined){
                    return new BigNumber(fillAmount)?.multipliedBy(Number(findProductRoute?.is_promo) === 2 ? findProductRoute?.price_promo : findProductRoute?.price )?.toString()
                }
                if (filterIsProduct !== undefined) {
                    return new BigNumber(fillAmount)?.multipliedBy(filterIsProduct?.price)?.toString()
                }
                return new BigNumber(fillAmount)?.multipliedBy(productRouteValue)?.toString()
            }
        }
        return ''
    },[fillAmount, cardProduct, findProductRoute, findPriceRoute, selectBrand, cardPrice, filterIsPrice, viewTag, sortBrandItemOne, sortBrandItemTwo])
    
    useEffect(() => {
        if((sortBrandItemOne?.length !== 0 ) && priceRoute){
            setViewTag('1')
        }
        if((sortBrandItemTwo?.length !== 0 ) && productRoute){
            setViewTag('2')
        }
    },[])
    
    useEffect(() => {
        if((cardProduct === undefined && productRoute && !isUpdate)){
            setViewTag('2')
        }
    },[ productRoute, cardProduct])
    
    useEffect(() => {
        if((sortBrandItemOne?.length !== 0 && sortBrandItemTwo?.length === 0  ) ){
            setViewTag('1')
        }
        if((sortBrandItemTwo?.length !== 0 && sortBrandItemOne?.length === 0)){
            setViewTag('2')
        }
    },[viewTag, selectBrand, sortBrandItemOne, sortBrandItemTwo, cardProduct])

    const contractAddress = getAddress(contracts.buyVouchers, chainId)
    
    const findTokenPayment = useMemo(() => {
        return tokenSupport.find((dt) => dt?.token?.address?.toLowerCase() === activeTokenPayment?.toLowerCase())
    },[tokenSupport, activeTokenPayment])
    
    UseCoreDataUser(contractAddress, account, findTokenPayment?.token, chainId, provider)

    UseCorePaymentMethod(totalPrice, chainId, provider, account)

    useEffect(() => {
        (async() => {
            const listTokenByTypeChain = listTokenGetBalance(chainId)
            const resListBalance = await fetchBalanceByChain(account, listTokenByTypeChain )
            await dispatch(fetchDataUserByChain(resListBalance))
        })()
    },[account, chainId, dispatch])
    const checkViewTag = viewTag === '1' ? 
            (priceRoute && !cardPrice) ? findPriceRoute?.id?.toString() : cardPrice?.id?.toString() 
            : (productRoute && !cardProduct) ? findProductRoute?.id?.toString() : cardProduct?.id?.toString()
    
    const checkViewTagBrand = viewTag === '1' ? 
            (priceRoute && !cardPrice) ? findPriceRoute?.brand?.toString() : cardPrice?.brand?.toString() 
            : (productRoute && !cardProduct) ? findProductRoute?.brand?.toString() : cardProduct?.brand?.toString()
    const checkViewTagNote = viewTag === '1' ? 
        (priceRoute && !cardPrice) ? findPriceRoute?.note?.toString() : cardPrice?.note?.toString() 
        : (productRoute && !cardProduct) ? findProductRoute?.note?.toString() : cardProduct?.note?.toString()
    const checkViewTagProvince = viewTag === '1' ? 
    (priceRoute && !cardPrice) ? findPriceRoute : cardPrice
    : (productRoute && !cardProduct) ? findProductRoute : cardProduct

    const handleContinue = async () => {
        if( !phoneAuth.match(phoneno) || 
        !emailAuth.match(mailformat) || 
        ( Number(fillAmount) < 1 || 
        Number(fillAmount) > 30) || 
        Number(fillAmount) > stockQuantity
        ) {
            setIsError(true)
            dispatch(getStatusLoading({ isLoading: false }))
        } else {
            setIsError(false)
        }
        if( isError === false && ( 
            phoneAuth.match(phoneno) 
            && emailAuth.match(mailformat) 
            && !new BigNumber(totalPrice)?.isNaN() 
            && checkViewTag
            && (fillAmount > 0 || fillAmount <= 30)
            && fillAmount <= stockQuantity
            )){
            await localStorage?.setItem("is_sign_again", "true")
            await dispatch(getStatusLoading({ isLoading: true }))
            try {
                const res = await BrandApi.order({ 
                    deliveryMethod,
                    phoneNo:phoneAuth,
                    email: emailAuth,
                    quantity:Number(fillAmount),
                    itemId: checkViewTag?.toString(),
                    chainId: chainId?.toString(),
                    isGiftCardVoucher: selectBrand?.isNewBrand ? !false : false
                })
                if(res?.statusCode === 201){
                    if(res?.data){
                        await dispatch(fetchDataVouchers({dataVouchers: {
                            deliveryMethod: res?.data?.deliveryMethod,
                            phoneNumber: res?.data?.phoneNo,
                            email: res?.data?.email,
                            fillAmount: res?.data?.quantity,
                            itemId: res?.data?.itemId,
                            nameProduct: res?.data?.itemName,
                            price: res?.data?.unitPrice,
                            promoPrice: res?.data?.promoPrice,
                            isPromo: res?.data?.isPromo,
                            orderId: res?.data?.orderId,
                            brandName: res?.data?.brandName,
                            viewTag,
                            tokenPayment: activeTokenPayment
                        }}))
                        await dispatch(fetchStatusScreen({isActiveScreen: 1}))
                        await dispatch(getStatusLoading({ isLoading: false }))
                    }
                } else {
                    await dispatch(fetchDataVouchers({dataVouchers: {
                        deliveryMethod: '',
                        phoneNumber: '',
                        email: '',
                        fillAmount: 0,
                        itemId: '',
                        nameProduct: '',
                        price: '',
                        promoPrice: '',
                        isPromo: 0,
                        orderId: "0",
                        brandName: '',
                        viewTag
                    }}))
                }

            } catch(e) {
                console.log('e', e)
                await dispatch(getStatusLoading({ isLoading: false }))
            }
        }
    }
    
    const isShowListByChangeCategory = useMemo(() => {
        if(isDefaultBrand === true && isDefaultProvince === true && selectCategory){
            return false
        }
        return true
    },[isDefaultBrand, isDefaultProvince, selectCategory])

    const handleChangeInfo = () => {
        onOpenModalInfo()
    }

    const [onOpenModalInfo] = useModal(
        <ModalInfo
            title=""
        />,
        true,
        true,
        `buy_item_${dataAuth}`
    );

    const funcCheckLink = ( priceParams, brandParams, prod, phoneNum) => {
        if(phoneNum){
            if( brandParams !== undefined  && prod !== undefined && phoneNum !== undefined){
                return `/order/${brandParams}?product=${prod}&phoneNumber=${phoneNum}`
            }
            if( brandParams !== undefined  && priceParams !== undefined && phoneNum !== undefined){
                return `/order/${brandParams}?price=${priceParams}&phoneNumber=${phoneNum}`
            }
            if(phoneNum !== undefined){
                return `/order?phoneNumber=${phoneNum}`
            }
        }

        if( brandParams !== undefined  && prod !== undefined){
            return `/order/${brandParams}?product=${prod}`
        }
        if( brandParams !== undefined  && priceParams !== undefined){
            return `/order/${brandParams}?price=${priceParams}`
        }
        if( brandParams !== undefined){
            return `/order/${brandParams}`
        }
        return `/order`
    }
    const deeplinkFunc = funcCheckLink((priceRoute && !cardPrice) ? findPriceRoute?.price : cardPrice?.price, resultFilterBrand?.id, (productRoute && !cardProduct) ? findProductRoute?.id : cardProduct?.id, phoneNumber)

    const listOffice = checkViewTagProvince || []

    const listProvineSupport = useMemo(() => {
        const listProvine: OptionProps[] = []
        if( listOffice?.office?.length > 0) {
            
            const mergeData = listOffice?.office?.map((it) => {
                const findItem = province.find((pr) => Number( pr?.provinceId) === Number(it?.city_id))
                return {
                    provinceName: findItem?.provinceName,
                    provinceId: findItem?.provinceId
                }
            }) 
            
            const result:OptionProps[] = mergeData && Object?.values(mergeData?.reduce((r, e) => {
                const k = `${e.provinceName}|${e.provinceId}`;
                if(!r[k]) r[k] = {...e, amount: 1}
                else r[k].amount += 1;
                return r;
              }, {}))
            
            return [
                {
                    provinceName: "Tất cả các khu vực",
                    provinceId: "0"
                },
                ...result || []
            ]
        }
        return listProvine
    },[brandItem?.length, listOffice])

    const [ selectProvinceState, setSelectProvinceState ] = useState(null)
    const handleSelectProvince = (option: OptionProps): void => {
        setSelectProvinceState(option)
    } 

    const filterCityIdCardPrice = useMemo(() => {
        const filter = checkViewTagProvince?.office?.filter((item) => item?.city_id?.toString() === selectProvinceState?.provinceId?.toString())
        if(Number(selectProvinceState?.provinceId) !== 0 && selectProvinceState?.provinceId !== undefined ){
            return filter
        }
        return checkViewTagProvince?.office
    },[selectProvinceState, checkViewTagProvince?.office])

    const filterCityIdCardProduct = useMemo(() => {
        const filter = checkViewTagProvince?.office?.filter((item) => item?.city_id?.toString() === selectProvinceState?.provinceId?.toString())
        if(Number(selectProvinceState?.provinceId) !== 0 && selectProvinceState?.provinceId !== undefined){
            return filter
        }
        return checkViewTagProvince?.office
    },[selectProvinceState, checkViewTagProvince?.office])

    const [isOpenLeft, setIsOpenLeft] = useState(true)
    const [isOpenRight, setIsOpenRight] = useState(true)

    const toggling = (event: React.MouseEvent<HTMLDivElement>) => {
        setIsOpenLeft(!isOpenLeft)
        event.stopPropagation()
    }

    const togglingRight = (event: React.MouseEvent<HTMLDivElement>) => {
        setIsOpenRight(!isOpenRight)
        event.stopPropagation()
    }
    const notes = cardPrice?.note?.split("\n")
    return (
        <>
            <PageFullWidth>
                <Container width="100%" mb="4rem" style={{overflowX: 'hidden'}}>
                    <Flex width="100%" flexDirection="column" style={{gap:"1rem"}}>
                        <Flex width="100%">
                            <Flex alignItems="center" style={{gap:"12px", cursor:"pointer", width: 'fit-content'}} onClick={() => handleBack()}>
                                <ArrowLeftCircle width="28px" />
                                <Heading scale="lg">Quay lại</Heading>
                            </Flex>
                        </Flex>
                        <Flex width="100%" mt="1rem">
                            <Flex width="100%" justifyContent="center" alignItems="center" flexDirection='column'>
                                <CsHeading scale="xl">Thẻ quà điện tử</CsHeading>
                            </Flex>
                        </Flex>

                        <Flex width="100%" justifyContent="space-between" alignItems="center" flexDirection="column">
                            <Flex width="100%" alignItems="flex-start" flexDirection="column">
                                <Heading mt="1rem" fontWeight="bold" scale="lg">Thông tin thẻ quà tặng</Heading>
                                <Text mt="0.5rem" fontSize={['12px', , '14px']}>Vui lòng điền đầy đủ thông tin thẻ quà tặng.</Text> 
                                <Text mt="1rem" fontSize={['14px', , '16px']} fontWeight="bold">Danh mục</Text>
                            </Flex>
                            <CsFlexMobile width="100%" style={{gap:"12px"}} mt="2rem">
                                <Flex width="100%" alignItems="center" flexDirection="row" justifyContent="space-between">
                                    <Swiper
                                        slidesPerView={5}
                                        pagination={{ clickable: true }}
                                        onSlideChange={() => console.log('slide change')}
                                        onSwiper={(swiper) => console.log(swiper)}
                                        spaceBetween={0}
                                        breakpoints={sliderSettings}
                                        modules={[Navigation]}
                                        onBeforeInit={(swiper) => {
                                            swiperRef.current = swiper;
                                        }}
                                    >
                                        { concatCategory?.map((dt) => {
                                                return (
                                                    <SwiperSlide>
                                                        <CsButton width={['100px', , '140px' ]}
                                                            variant={new BigNumber(selectCategory).isEqualTo(dt?.id)  ? "primary" :"text"}
                                                            onClick={() => handleChangeCategory(dt?.id)}
                                                        >
                                                            {dt?.title}
                                                        </CsButton>
                                                    </SwiperSlide>
                                                )
                                            })
                                        }
                                    </Swiper>
                                    <CsFlexNext onClick={() => swiperRef.current?.slideNext()}>
                                        <ArrowLeftCircle width="32px" style={{cursor:"pointer", transform:"rotate(180deg)"}} />
                                    </CsFlexNext>
                                </Flex>
                            </CsFlexMobile>
                            <CsFlexPc width="100%" alignItems="center" flexDirection="row" justifyContent="space-between" mt="1rem">
                                { concatCategory?.map((dt) => {
                                        return (
                                                <CsButton width={['100px', , '140px' ]}
                                                    variant={new BigNumber(selectCategory).isEqualTo(dt?.id)  ? "primary" :"text"}
                                                    onClick={() => handleChangeCategory(dt?.id)}
                                                >
                                                    {dt?.title}
                                                </CsButton>
                                        )
                                    })
                                }
                            </CsFlexPc>

                            <Filter
                                setFillAmount={(newAmount) => dispatch(fetchFillAmount({fillAmount: newAmount}))}
                                fillAmount={fillAmount}
                                setSelectBrand={setSelectBrand}
                                selectBrand={selectBrand}
                                handleChangeInput={handleChangeInput}
                                handleSelectReliGion={handleSelectReliGion}
                                resultFilterProvince={resultFilterProvince}
                                isError={isError}
                                isDefaultBrand={isDefaultBrand}
                                isDefaultProvince={isDefaultProvince}
                                setIsDefaultBrand={setIsDefaultBrand}
                                stockQuantity={stockQuantity}
                                filterIsPrice={filterIsPrice}
                                filterIsProduct={filterIsProduct}
                                findProductRoute={findProductRoute}
                                cardPrice={cardPrice}
                                cardProduct={cardProduct}
                                viewTag={viewTag}
                                selectCategory={selectCategory}
                                priceRoute={priceRoute}
                                brandRoute={brandRoute}
                                setOptionSelected={setOptionSelected}
                                optionSelected={optionSelected}
                                setCardPrice={setCardPrice}
                            />
                        </Flex>
                        {((brandRoute || priceRoute ) || (filterIsPrice || filterIsProduct) || resultFilterBrand !== undefined ) && isShowListByChangeCategory ? (
                            <>
                                {
                                    (resultFilterTypeOne?.length !== 0 || filterTypeTwo?.length !== 0) ?
                                    <>
                                        <Flex width="100%" alignItems="center" justifyContent="center" mt={["3rem", ,"5rem"]} style={{gap: '1rem'}}>
                                            <CsButtonTab 
                                                disabled={sortBrandItemOne?.length === 0}
                                                width={['140px', , '180px']} 
                                                variant={(viewTag === '1')  ? "primary" :"text"}
                                                onClick={() => setViewTag('1')}
                                            >
                                                Mệnh giá
                                            </CsButtonTab>

                                            <CsButtonTab 
                                                disabled={sortBrandItemTwo?.length === 0}
                                                width={['140px', , '180px']} 
                                                variant={(viewTag === '2')  ? "primary" :"text"}
                                                onClick={() => setViewTag('2')}
                                            >
                                                Sản phẩm nổi bật
                                            </CsButtonTab>
                                        </Flex>
                                        <Flex width="100%" justifyContent="space-between" alignItems="center" flexDirection="row" style={{transform: 'translateY(-100px)'}}>
                                            <Flex width="100%" alignItems="center"  justifyContent="space-between">
                                                <Flex>
                                                    <Text fontWeight="bold">Chọn giá trị thẻ quà</Text> <Text ml="4px" color="red">*</Text>
                                                </Flex>
                                            </Flex>
                                        </Flex>
                                    </>
                                    : ''
                                }

                                <GiftCardList
                                    priceItem={!cardPrice ? priceRoute?.toString() : cardPrice?.price?.toString() }
                                    viewTag={viewTag}
                                    setViewTag={setViewTag}
                                    handleSelectPrice={handleSelectPrice}
                                    handleSelectCard={handleSelectCard}
                                    brandItem={(!Number(resultFilterBrand?.id) && !productRoute?.toString()) ? noProduct : brandItem}
                                    sortBrandItemOne={sortBrandItemOne}
                                    sortBrandItemTwo={sortBrandItemTwo}
                                    activeItem={!cardProduct ? findProductRoute : cardProduct }
                                    isDefaultBrand={isDefaultBrand}
                                    isDiffercent={viewTag === '1' ? (checkViewTagBrand !== selectBrand?.id) : (checkViewTagBrand !== selectBrand?.id)}
                                    isResultFilterProvince={resultFilterProvince?.length > 0}
                                />
                            </> 
                        ) : 
                            ''
                         }

                         {
                            <>
                                { cardPrice?.isNewBrand ?
                                    <>
                                        { checkViewTagBrand &&
                                            <CsWrapPolicy width="100%">
                                                    <Flex width={["100%",,,"45%"]} flexDirection="column" style={{gap:"12px"}}>
                                                        <Flex width="100%" justifyContent="space-between">
                                                            <Heading scale="lg">Điều kiện sử dụng</Heading>
                                                            <CsIconSort color="black" onClick={toggling} style={{ transform: isOpenLeft && 'rotate(180deg)' }} />
                                                        </Flex>
                                                        
                                                        <ContainerNote isOpen={isOpenLeft}>
                                                            {
                                                                isLoading ? <Flex width="100%" height="100%" justifyContent="center" flexDirection="column" alignItems="center"><Spin size="small"/></Flex> :
                                                                <>
                                                                    {checkViewTagNote ?
                                                                                <Text>
                                                                                    {notes?.map((dt) => {
                                                                                        return (
                                                                                            <p>{dt}</p>
                                                                                        )
                                                                                    })}
                                                                                </Text>
                                                                                :
                                                                                !checkViewTagNote && <Text textAlign="center" mt="2rem">Không có dữ liệu</Text>
                                                                            }
                                                                </>
                                                            }
                                                        </ContainerNote>
                                                    </Flex>
                                                    <Flex width={["100%",,,"45%"]} flexDirection="column" style={{gap:"12px"}}>
                                                        <Flex width="100%" justifyContent="space-between" flexWrap="wrap" alignItems="center" style={{gap:"12px"}}>
                                                            <Flex width="100%" justifyContent="space-between">
                                                                <Heading scale="lg">Địa điểm áp dụng</Heading>
                                                                <CsIconSort color="black" onClick={togglingRight} style={{ transform: isOpenRight && 'rotate(180deg)' }} />
                                                            </Flex>
                                                        </Flex>
                                                        <CsWrapContainerScroll isOpen={isOpenRight}>
                                                            {
                                                                isLoading ? <Flex width="100%" height="100%" justifyContent="center" flexDirection="column" alignItems="center"><Spin size="small"/></Flex> :
                                                                <>
                                                                    <SelectProvinceHome className="select-office-main"
                                                                        options={listProvineSupport?.length === 0 ? [] : listProvineSupport }
                                                                        placeHolderText="Tất cả các khu vực"
                                                                        onOptionChange={handleSelectProvince}
                                                                        isDefaultProvince={false}
                                                                        selectedOption={province?.find((item) => item?.provinceId?.toString() === selectProvinceState?.toString()) || selectProvinceState} 
                                                                        isLoading={false}    
                                                                        disabled={selectBrand?.isNewBrand}             
                                                                    />
                                                                    <ContainerScroll>
                                                                        <>
                                                                        {cardPrice?.office?.map((dt) => {
                                                                                                        return (
                                                                                                            <ContainerCard>
                                                                                                                <Flex width="60px">
                                                                                                                    <LocationV2Icon/>
                                                                                                                </Flex>
                                                                                                                <Flex width="100%">
                                                                                                                        <Text>{dt}</Text>
                                                                                                                </Flex>
                                                                                                                
                                                                                                            </ContainerCard>
                                                                                                        )
                                                                                                    })
                                                                                                }
                                                                        </>
                                                                    </ContainerScroll>
                                                                </>
                                                            }
                
                                                        </CsWrapContainerScroll>
                                                    </Flex>
                                                </CsWrapPolicy>
                                        }
                                    </>
                                :
                                    <>
                                        {
                                            (( (isDefaultBrand === false && checkViewTagProvince) && ((checkViewTagBrand === selectBrand?.id) || (checkViewTagBrand === selectBrand?.id) )) && resultFilterProvince?.length > 0) && (
                                                <CsWrapPolicy width="100%">
                                                    <Flex width={["100%",,,"45%"]} flexDirection="column" style={{gap:"12px"}}>
                                                        <Flex width="100%" justifyContent="space-between">
                                                            <Heading scale="lg">Điều kiện sử dụng</Heading>
                                                            <CsIconSort color="black" onClick={toggling} style={{ transform: isOpenLeft && 'rotate(180deg)' }} />
                                                        </Flex>
                                                        
                                                        <ContainerNote isOpen={isOpenLeft}>
                                                            {
                                                                isLoading ? <Flex width="100%" height="100%" justifyContent="center" flexDirection="column" alignItems="center"><Spin size="small"/></Flex> :
                                                                <>
                                                                    {
                                                                        (priceRoute ||cardPrice) && <>
                                                                            {checkViewTagNote ?
                                                                                // eslint-disable-next-line react/no-danger
                                                                                <div dangerouslySetInnerHTML={{ __html: checkViewTagNote }} />
                                                                                :
                                                                                !checkViewTagNote && <Text textAlign="center" mt="2rem">Không có dữ liệu</Text>
                                                                            }
                                                                        </>
                                                                    }
                                                                    {
                                                                        (productRoute || cardProduct) && 
                                                                        <>
                                                                            { checkViewTagNote ?
                                                                                // eslint-disable-next-line react/no-danger
                                                                                <div dangerouslySetInnerHTML={{ __html: checkViewTagNote }} />
                                                                                :
                                                                                !checkViewTagNote && <Text textAlign="center" mt="2rem">Không có dữ liệu</Text>
                                                                            }
                                                                        </>
                                                                    }
                                                                </>
                                                            }
                                                        </ContainerNote>
                                                    </Flex>
                                                    <Flex width={["100%",,,"45%"]} flexDirection="column" style={{gap:"12px"}}>
                                                        <Flex width="100%" justifyContent="space-between" flexWrap="wrap" alignItems="center" style={{gap:"12px"}}>
                                                            <Flex width="100%" justifyContent="space-between">
                                                                <Heading scale="lg">Địa điểm áp dụng</Heading>
                                                                <CsIconSort color="black" onClick={togglingRight} style={{ transform: isOpenRight && 'rotate(180deg)' }} />
                                                            </Flex>
                                                        </Flex>
                                                        <CsWrapContainerScroll isOpen={isOpenRight}>
                                                            {
                                                                isLoading ? <Flex width="100%" height="100%" justifyContent="center" flexDirection="column" alignItems="center"><Spin size="small"/></Flex> :
                                                                <>
                                                                    <SelectProvinceHome className="select-office-main"
                                                                        options={listProvineSupport?.length === 0 ? [] : listProvineSupport }
                                                                        placeHolderText="Tất cả các khu vực"
                                                                        onOptionChange={handleSelectProvince}
                                                                        isDefaultProvince={false}
                                                                        selectedOption={province?.find((item) => item?.provinceId?.toString() === selectProvinceState?.toString()) || selectProvinceState} 
                                                                        isLoading={false}    
                                                                        disabled={selectBrand?.isNewBrand}             
                                                                    />
                                                                    <ContainerScroll>
                                                                        <>
                                                                            {
                                                                                (priceRoute || cardPrice) && <>
                                                                                {
                                                                                    // filterCityIdCardPrice?.length === 0 || filterCityIdCardPrice === undefined ?
                                                                                        // <Text textAlign="center" mt="2rem">Không có dữ liệu</Text> :
                                                                                    <>
                                                                                        { filterCityIdCardPrice?.length > 0 &&
                                                                                            <>
                                                                                                {filterCityIdCardPrice.map((dt) => {
                                                                                                        return (
                                                                                                            <ContainerCard>
                                                                                                                <Flex width="60px">
                                                                                                                    <LocationV2Icon/>
                                                                                                                </Flex>
                                                                                                                { selectBrand?.isNewBrand ?
                                                                                                                    <Flex width="100%">
                                                                                                                        <Text>{dt}</Text>
                                                                                                                    </Flex>
                                                                                                                :
                                                                                                                    <Flex width="100%">
                                                                                                                        <Text>{dt?.address}</Text>
                                                                                                                    </Flex>
                                                                                                                }
                                                                                                                
                                                                                                            </ContainerCard>
                                                                                                        )
                                                                                                    })
                                                                                                }
                                                                                            </>
                                                                                        }
                                                                                    </>
                                                                                }
                                                                                </>
                                                                            }
                                                                            {
                                                                                (productRoute || cardProduct) && <>
                                                                                { filterCityIdCardProduct?.length > 0 &&
                                                                                        <>
                                                                                            {filterCityIdCardProduct?.map((dt) => {
                                                                                                    return (
                                                                                                        <ContainerCard>
                                                                                                            <Flex width="60px">
                                                                                                                <LocationV2Icon/>
                                                                                                            </Flex>
                                                                                                            <Flex width="100%">
                                                                                                                <Text>{dt?.address}</Text>
                                                                                                            </Flex>
                                                                                                        </ContainerCard>
                                                                                                    )
                                                                                                })
                                                                                            }
                                                                                        </>
                                                                                    }
                                                                                </>
                                                                            }
                                                                        </>
                                                                    </ContainerScroll>
                                                                </>
                                                            }
                
                                                        </CsWrapContainerScroll>
                                                    </Flex>
                                                </CsWrapPolicy>
                                            )
                                        }
                                    </>
                                }
                            </>
                           
                         }

                        <Info
                            router={deeplinkFunc}
                            phoneNumber={phoneAuth}
                            phoneNumberRoute={phoneNumberRoute}
                            setPhoneNumber={(newPhoneNumber) => {
                                dispatch(fetchFillPhoneNumber({phoneNumber: newPhoneNumber}));
                            }}
                            email={emailAuth}
                            setEmail={(newEmail) => dispatch(fetchFillEmail({email: newEmail}))}
                            setDeliveryMethod={setDeliveryMethod}
                            deliveryMethod={deliveryMethod}
                            isError={isError}
                            handleChangeInfo={handleChangeInfo}
                            account={account}
                        />

                        {
                            (((brandRoute || priceRoute ) || (filterIsPrice || filterIsProduct) || resultFilterBrand !== undefined ) && isShowListByChangeCategory) ?
                            <>
                                <Flex justifyContent="flex-start" alignItems="center" mt={["0.5rem", , ,"1rem"]}>
                                    <Text width={["150px", , "200px"]} fontSize={['14px', , '16px']}>Tên sản phẩm</Text>
                                    <CsFlexInfo justifyContent="flex-start" alignItems="center" flexDirection="column">
                                        <Text fontSize={['14px', , '16px']}>
                                        {
                                            viewTag === '1' ?
                                            <>
                                            {
                                                isDefaultBrand ? <></> : 
                                                <>
                                                    {(priceRoute && !cardPrice) ? `${voucherName} ${selectBrand?.title} ${formatNumber(priceRoute)}${UNIT_TOKEN}` : 
                                                    <>{(filterIsPrice && cardPrice) && `${voucherName} ${selectBrand?.title} ${formatNumber(cardPrice?.price)}${UNIT_TOKEN}` }</>}
                                                </>
                                            }
                                            </>
                                            :
                                            <>
                                                { isDefaultBrand ? '' : 
                                                    <>
                                                        {(productRoute && !cardProduct) ? 
                                                            productRoute ? `${voucherName} ${findProductRoute?.title}` : cardProduct?.title : 
                                                                <> {(filterIsProduct && cardProduct)  && `${voucherName}] ${cardProduct?.title?.replace(voucherName, '')}`}</>
                                                        }
                                                    </>
                                                }
                                            </>
                                        }
                                        </Text>
                                    </CsFlexInfo>
                                </Flex>

                                <Flex justifyContent={["space-between", ,"flex-start"]} alignItems="center">
                                    <Text width={["150px", , "200px"]} fontSize={['14px', , '16px']}>Nhà cung cấp</Text>
                                    <CsFlexInfo justifyContent="flex-start" alignItems="center" flexDirection="column">
                                        <Text fontSize={['14px', , '16px']}>
                                            {isDefaultBrand ? '' :
                                                productRoute ? (selectBrand ? selectBrand?.title : findProductRoute?.brand_name) : selectBrand?.title
                                            }
                                            </Text>
                                    </CsFlexInfo>
                                </Flex>
                            </>
                            : ''
                        }
                        <Flex width="100%" justifyContent={["space-between", ,"flex-start"]} >
                            <Text width={["150px", , "200px"]} fontSize={['14px', , '16px']}>Số điện thoại</Text>
                            <CsFlexInfo justifyContent="flex-start" alignItems={["flex-end",,"flex-start"]} flexDirection="column">
                                <Text fontSize={['14px', , '16px']}>{phoneAuth}</Text>
                            </CsFlexInfo>
                        </Flex>

                        <Flex width="100%" justifyContent={["space-between", ,"flex-start"]} >
                            <Text width={["150px", , "200px"]} fontSize={['14px', , '16px']}>Email</Text>
                            <CsFlexInfo justifyContent="flex-start" alignItems={["flex-end",,"flex-start"]} flexDirection="column">
                                <Text fontSize={['14px', , '16px']}>{emailAuth}</Text>
                            </CsFlexInfo>
                        </Flex>


                        <Flex width="100%" justifyContent={["space-between", ,"flex-start"]} >
                            <Text width={["150px", , "200px"]} fontSize={['14px', , '16px']}>Tổng giá trị</Text>
                            <CsFlexInfo justifyContent="flex-start" alignItems={["flex-end",,"flex-start"]} flexDirection="column">
                                <Text fontWeight={700} fontSize={['14px', , '16px']}>{isDefaultBrand ? `0${UNIT_TOKEN}` : <> {formatNumber(totalPrice)} {UNIT_TOKEN} </> } </Text>
                                { findTokenPayment &&
                                    <SubBalance fontSize={['12px', , '14px']}>{isDefaultBrand ? `0 điểm ${findTokenPayment?.token?.symbol}` : `Tương đương ${formatNumberv2(findTokenPayment?.exchangeRate, findTokenPayment?.token?.symbol)} điểm ${findTokenPayment?.token?.symbol}` }</SubBalance>
                                }
                            </CsFlexInfo>
                        </Flex>

                        <Text mt="1rem" mb="1rem" fontWeight="bold" fontSize={['14px', , '16px']} color="red">*Lưu ý: Vui lòng kiểm tra thông tin trước khi tiếp tục</Text>

                        <Flex minWidth="40%" justifyContent="space-between" alignItems="center">
                            {!account ?
                                <ConnectWalletButton
                                    routePath={deeplinkFunc}
                                >
                                    Kết nối ví
                                    <IconSort ml='4px' color="white" style={{transform: 'rotate(270deg)'}} />
                                </ConnectWalletButton>
                            :
                            <CsButtonContinue
                                onClick={handleContinue}
                                style={{cursor:"pointer"}}
                                endIcon={ isLoading ? <AutoRenewIcon color="white" spin /> : <IconSort ml='4px' color="white" style={{transform: 'rotate(270deg)'}} />}
                                disabled={
                                    isLoading ||
                                    !phoneAuth?.match(phoneno) || 
                                    !emailAuth?.match(mailformat) || 
                                    ( Number(fillAmount) < 1 || Number(fillAmount) > 30) || 
                                    (Number(fillAmount) > stockQuantity) ||
                                    (cardProduct === null && priceRoute === undefined) && 
                                    (cardPrice === null && productRoute === undefined) ||
                                    resultFilterProvince?.length === 0 ||
                                    !findTokenPayment
                                }
                            >
                                Tiếp tục
                                
                            </CsButtonContinue>
                            }
                        </Flex>
                    </Flex>
                </Container>
            </PageFullWidth>
        </>
    )
}

const CsButtonContinue = styled(Button)`
    border-radius: 4px;
`
const CsFlexNext = styled(Flex)`
    display: none;
    @media screen and (max-width: 1023px){
        display: flex;
        cursor: pointer;
        width: 40px;
        height: 40px;
        justify-content: center;
        &:active{
            border: 1px solid red;
            border-radius: 50%;
            border: 2px solid ${({ theme }) => theme.colors.backgroundDisabled};
        }
    }
    @media screen and (max-width:600px){
        width: 24px;
        height: 24px;
        z-index:1;
    }
`
const CsFlexInfo = styled(Flex)`
    @media screen and (max-width:600px){
        justify-content: flex-end;
        ${Text}{
            text-align: right;
        }
    }
`
const CsFlexMobile = styled(Flex)`
        display: none;
        @media screen and (max-width:600px){
        display: flex;
    }
`
const CsFlexPc = styled(Flex)`
        display: flex;
        @media screen and (max-width:600px){
            display: none;
    }
`

const ContainerNote = styled.div<{isOpen: boolean}>`
    display: flex;
    height: ${({isOpen}) => isOpen ? '200px' : '0'};
    overflow-y: auto;
    flex-direction: column;
    gap:12px;
    transition: 0.2s;
    color:#000;
    margin-bottom: 2rem;
    ::-webkit-scrollbar-thumb {
        border-radius: 6px;
        background: linear-gradient(180deg, #0167F4 0%, #012179 100%);
    }
    > div {
        padding-right: 12px;

    }
    > div > ul {
        list-style:none;
        list-style-position: outside;
        font-style: normal;
        font-weight: 400;
        line-height: 150%; /* 36px */
        letter-spacing: -0.48px;
        text-align:justify;
        padding-top:12px;
        font-size:16px;
    }
    > div > ul > li {
        padding-bottom: 8px;
        list-style:none;
        list-style-position: outside;
        font-size:14px;
        @media screen and (max-width: 768px){
            font-size:12px;
        }
    }
    > ul {
        line-height: 150%; /* 36px */
        list-style:none;
        list-style-position: outside;
        font-size:16px;
    }
    ol, ul {
        list-style: disc;
        list-style-position: outside;
        line-height: 150%; /* 36px */
        text-align:justify;
        font-size:16px;
    }
    span,p{
        line-height: 150%; /* 36px */
        font-size:14px !important;
        @media screen and (max-width: 768px){
            font-size:12px !important;
        }
    }
`
const CsWrapContainerScroll = styled(Flex)<{isOpen:boolean}>`
    height: ${({isOpen}) => isOpen ? '200px' : '0'};
    transition: 0.2s;
    flex-direction:column;
    .select-office-main{
        display: ${({isOpen}) => isOpen ? 'block' : 'none'};
    }
`
const ContainerScroll = styled(Flex)`
    width: 100%;
    margin-top: 1rem;
    flex: 1;
    overflow-y: auto;
    flex-direction:column;
    gap: 12px;
    padding-right: 12px;
    @media screen and (max-width: 768px){
        gap: 6px;
        margin-top: 0.5rem;
    }
    ::-webkit-scrollbar-thumb {
        border-radius: 6px;
        background: linear-gradient(180deg, #0167F4 0%, #012179 100%);
    }
`
const ContainerCard = styled(Flex)`
    width: 100%;
    height: fit-content;
    min-height: 88px;
    background:${({ theme }) => theme.colors.white};
    box-shadow: 0px 8px 24px 0px rgba(216, 216, 216, 0.10);
    border-radius: 8px;
    padding: 1rem;
    align-items: center;
    @media screen and (max-width: 768px){
        min-height: 60px;
        padding: 0.5rem;
    }
`
const CsWrapPolicy = styled(Flex)`
    /* box-shadow: 0px 8px 24px 0px #d8d8d834; */
    padding: 20px 0;
    height: fit-content;
    width: 100%;
    justify-content: space-between;
    flex-direction:row;
    @media screen and (max-width: 768px){
        flex-direction:column;
        height: fit-content;
    }
`

const CsIconSort = styled(ArrowDownIcon2)`
    width: 30px;
    height: 30px;
    padding: 8px;
    border-radius: 50%;
    border: 2px solid ${({theme}) => theme.colors.border};
    cursor: pointer;
`

export default ElectronicGiftCard